// extracted by mini-css-extract-plugin
export default {"content":"EpisodeDetails_content__6A5XM","fadein":"EpisodeDetails_fadein__UkbBD","links":"EpisodeDetails_links__tmXLW"};